module.exports = __webpack_public_path__ + "static/media/r410.fc587fac.jpg";